import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    metaHeaderRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    metaInfoRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    emptyStateContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 240
    },
    statusBadge: {
        alignSelf: "flex-start"
    },
    previewFrameContainer: {
        minHeight: 380,
        width: "100%"
    },
    previewContainer: {
        overflow: "hidden",
        width: "100%"
    },
    receiversContainer: {
        width: "100%"
    },
    contentContainer: {
        maxHeight: 700,
        width: "100%"
    },
    previewIframe: {
        borderWidth: 0,
        minHeight: 450,
        width: "100%"
    },
    container: {
        maxWidth: 700,
        width: "100%"
    },
    previewHeader: {
        width: "100%"
    },
    metaContainer: {
        width: "100%"
    }
});
export default stylesheet;
